module.exports = __webpack_public_path__ + "media/images/new-ui-images/pdfblue-16a411883bd425246f8dda6ad3535615.svg";